// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"15":"2bc90d46","290":"3e431060"}[chunkId] + ".chunk.js";
};